import { render, staticRenderFns } from "./NoticeBoard.vue?vue&type=template&id=1741dd09"
import script from "./NoticeBoard.vue?vue&type=script&lang=js"
export * from "./NoticeBoard.vue?vue&type=script&lang=js"
import style0 from "./NoticeBoard.vue?vue&type=style&index=0&id=1741dd09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports